<div class="col-xl">
    <form id="formService" *ngIf="dataMaintenance">
        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Ver solicitud</h4>
            </div>

            <!-- Info -->
            <div class="card-body">
                <div class="mb-3 p-3 border rounded">
                    <div class="row g-3">
                        <div class="col-12 col-sm-4 col-lg">
                            <h6><b>Fecha de Solicitud</b></h6>
                            <label class="form-label">{{ dataMaintenance.request_date | date:'dd/MM/yyyy' }}</label>
                        </div>
                        <div class="col-12 col-sm-4 col-lg">
                            <h6><b>Hora de solicitud</b></h6>
                            <label class="form-label">{{ dataMaintenance.request_hour }}</label>
                        </div>
                        <div class="col-12 col-sm-4 col-lg">
                            <h6><b>Usuario</b></h6>
                            <label class="form-label">{{dataMaintenance?.user?.name}}</label>
                        </div>
                        <div class="col-12 col-sm-6 col-lg">
                            <h6><b>Unidad</b></h6>
                            <label class="form-label">{{dataMaintenance?.unit?.unit}}</label>
                        </div>
                        <div class="col-12 col-sm-6 col-lg">
                            <h6><b>Placas</b></h6>
                            <label class="form-label">{{dataMaintenance?.unit?.plates}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Clasificación -->
            <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                <h4 class="mb-0">Clasificación de la solicitud</h4>
            </div>
            <div class="card-body mt-0 pb-1">
                <div class="mb-3 p-3 border rounded">
                    <span class="btn btn-primary btn-priority">{{dataMaintenance?.priority?.name}}</span>
                </div>
            </div>

            <!-- Especificación de la falla (Crítico / Reparación) -->
            <ng-container *ngIf="isCriticoOrReparacion">
                <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                    <h4 class="mb-0">Especificación de la falla</h4>
                </div>
                <div class="card-body">
                    <div class="mb-3 p-3 border rounded">
                        <div class="row g-3">
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>¿Donde se encuentra la falla?</b></h6>
                                <label class="form-label">{{dataMaintenance?.maintenance_failure?.name || '—'}}</label>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>¿Que tipo de falla es?</b></h6>
                                <label class="form-label">{{dataMaintenance?.maintenance_failure_type?.name || '—'}}</label>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>Detalle de la falla</b></h6>
                                <label class="form-label">{{dataMaintenance?.maintenance_detail?.name || '—'}}</label>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>Km inicial de la unidad</b></h6>
                                <label class="form-label">{{dataMaintenance?.km_inicial != null ? (dataMaintenance.km_inicial + ' Km') : '—'}}</label>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>Tipo de mantenimiento</b></h6>
                                <label class="form-label">{{dataMaintenance?.maintenance_type?.name || '—'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Especificaciones de la solicitud (Preventivo) -->
            <ng-container *ngIf="isPreventivo">
                <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                    <h4 class="mb-0">Especificaciones de la solicitud</h4>
                </div>
                <div class="card-body">
                    <div class="mb-3 p-3 border rounded">
                        <div class="row g-3">
                            <div class="col-12 col-md-6">
                                <h6><b>Km inicial de la unidad a la fecha de la solicitud</b></h6>
                                <label class="form-label">{{dataMaintenance?.km_inicial != null ? (dataMaintenance.km_inicial + ' Km') : '—'}}</label>
                            </div>
                            <div class="col-12 col-md-6">
                                <h6><b>Km estipulado para su próximo mantenimiento</b></h6>
                                <label class="form-label">{{dataMaintenance?.km_next_maintenance != null ? (dataMaintenance.km_next_maintenance + ' Km') : '—'}}</label>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>Tipo de mantenimiento</b></h6>
                                <label class="form-label">{{dataMaintenance?.maintenance_type?.name || '—'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Evidencias -->
            <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                <h4 class="mb-0">Evidencias</h4>
            </div>
            <div class="card-body mt-0 mb-0">
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-lg-12 col-xs-12">
                            <div *ngIf="dataMaintenance?.evidences?.length" class="mt-2 evidence-previews">
                                <ng-container *ngFor="let preview of dataMaintenance?.evidences; let i = index">
                                    <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                        <img [src]="urlPage + '/storage/' + preview.path" alt="preview"
                                            class="thumb-image" />
                                    </div>
                                </ng-container>
                            </div>
                            <p *ngIf="!dataMaintenance?.evidences?.length" class="text-muted mb-0">Sin evidencias</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Materiales y refacciones -->
            <ng-container *ngIf="isInternal">
                <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                    <h4 class="mb-0">Materiales y refacciones</h4>
                </div>
                <div class="card-body mt-0 pb-1">
                    <div class="mb-3 p-3 border rounded">

                        <!-- Refacciones -->
                        <h6 class="mb-2"><b>Refacciones</b></h6>
                        <div class="mt-2 mb-3">
                            <ag-grid-angular
                                class="ag-theme-alpine spare-grid"
                                [columnDefs]="spareColDefs"
                                [defaultColDef]="spareDefaultColDef"
                                [rowData]="dataMaintenance?.repair_requests ?? []"
                                [domLayout]="'autoHeight'"
                                [overlayNoRowsTemplate]="'<span class=\'text-muted\'>Sin refacciones registradas</span>'"
                                (gridReady)="onSpareGridReady($event)">
                            </ag-grid-angular>
                            <div class="d-flex justify-content-end align-items-center pt-2 border-top"
                                *ngIf="dataMaintenance?.repair_requests?.length > 0">
                                <div>
                                    <strong>Total refacciones: </strong>
                                    <span class="text-primary fw-bold fs-5">
                                        ${{ totalRepairs | number:'1.2-2' }} MXN
                                    </span>
                                </div>
                            </div>
                        </div>

                        <hr class="my-3">

                        <!-- Mano de obra -->
                        <h6 class="mb-2"><b>Mano de obra externa</b></h6>
                        <ng-container *ngIf="dataMaintenance?.required_labor">
                            <div class="row g-3">
                                <div class="col-12 col-md-6">
                                    <h6><b>Costo de mano de obra</b></h6>
                                    <label class="form-label">
                                        {{dataMaintenance?.labor_cost != null ? ('$' + (dataMaintenance.labor_cost | number:'1.2-2') + ' MXN') : '—'}}
                                    </label>
                                </div>
                                <div class="col-12" *ngIf="dataMaintenance?.labor_description">
                                    <h6><b>Descripción</b></h6>
                                    <label class="form-label">{{dataMaintenance.labor_description}}</label>
                                </div>
                            </div>
                        </ng-container>
                        <p *ngIf="!dataMaintenance?.required_labor" class="text-muted mb-0">No requiere mano de obra externa.</p>
                    </div>
                </div>
            </ng-container>

            <!-- Fecha estimada de reparación -->
            <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                <h4 class="mb-0">Fecha estimada de reparación</h4>
            </div>
            <div class="card-body mt-0 pb-1">
                <div class="mb-3 p-3 border rounded">
                    <div class="row g-3">
                        <div class="col-auto d-flex align-items-center gap-2">
                            <h6 class="mb-0"><b>Desde</b></h6>
                            <label class="form-label mb-0">
                                {{dataMaintenance?.estimated_time_repair_start ? (dataMaintenance.estimated_time_repair_start | date:'dd/MM/yyyy') : '—'}}
                            </label>
                        </div>
                        <div class="col-auto d-flex align-items-center gap-2">
                            <h6 class="mb-0"><b>Hasta</b></h6>
                            <label class="form-label mb-0">
                                {{dataMaintenance?.estimated_time_repair_end ? (dataMaintenance.estimated_time_repair_end | date:'dd/MM/yyyy') : '—'}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Resumen financiero -->
            <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0"
                *ngIf="dataMaintenance?.maintenance_status?.name != 'Denegado' && dataMaintenance?.supplier">
                <h4 class="mb-0">Resumen financiero</h4>
            </div>
            <div class="card-body mt-0 mb-0"
                *ngIf="dataMaintenance?.maintenance_status?.name != 'Denegado' && dataMaintenance?.supplier">
                <div class="mb-3 p-3 border rounded">
                    <div class="row mb-3">
                        <div class="col">
                            <h6><b>Costo del servicio</b></h6>
                            <label class="form-label">{{dataMaintenance?.supplier?.cost | currency}}</label>
                        </div>
                        <div class="col">
                            <h6><b>Tiempo estimado de reparación</b></h6>
                            <label class="form-label">{{dataMaintenance?.supplier?.estimated_time}} Dias</label>
                        </div>
                        <div class="col">
                            <h6><b>Ubicación del taller</b></h6>
                            <a class="lh-1" target="_blank">{{dataMaintenance?.supplier?.supplier?.direction_address}}</a>
                        </div>
                        <div class="col"></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col">
                            <h6><b>Banco</b></h6>
                            <label class="form-label">{{dataMaintenance?.supplier?.supplier?.bank.name}}</label>
                        </div>
                        <div class="col">
                            <h6><b>Número de cuenta</b></h6>
                            <label class="form-label">{{dataMaintenance?.supplier?.supplier?.account_number || 'N/A'}}</label>
                        </div>
                        <div class="col">
                            <h6><b>Nombre del titular</b></h6>
                            <label class="form-label">{{dataMaintenance?.supplier?.supplier?.account_name || 'N/A'}}</label>
                        </div>
                        <div class="col">
                            <h6><b>Tipo de pago</b></h6>
                            <label class="form-label">{{dataMaintenance?.supplier?.payment_type?.name || 'N/A'}}</label>
                        </div>
                        <div class="col">
                            <h6><b>Porcentaje pago parcial</b></h6>
                            <label class="form-label">{{dataMaintenance?.payment_request?.percentage || 'N/A'}} {{dataMaintenance?.payment_request?.percentage_type?.name ? '%' : ''}}</label>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col">
                            <h6><b>Monto restante</b></h6>
                            <label class="form-label">
                                {{dataMaintenance?.payment_request?.remaining_amount
                                    ? (dataMaintenance?.payment_request?.remaining_amount | currency)
                                    : 'N/A'}}
                            </label>
                        </div>
                        <div class="col">
                            <h6><b>Fecha liquidación</b></h6>
                            <label class="form-label">{{dataMaintenance?.payment_request?.settlement_date ? (dataMaintenance?.payment_request?.settlement_date | date:'dd/MM/yyyy') : 'N/A'}}</label>
                        </div>
                        <div class="col">
                            <h6><b>Cotización</b></h6>
                            <div class="d-flex align-items-center">
                                <img src="assets/img/icons/maintenance/pdf-02.svg" alt="PDF" width="20" class="me-2">
                                <a class="me-2" [href]="urlPage + '/storage/' + dataMaintenance?.supplier?.attached_url"
                                    target="_blank" rel="noopener">
                                    Ver cotización existente
                                </a>
                            </div>
                        </div>
                        <div class="col"></div>
                    </div>
                </div>
            </div>

            <!-- Comparativo de proveedores -->
            <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0"
                *ngIf="dataMaintenance?.supplier_show?.length > 0">
                <h4 class="mb-0">Comparativo de proveedores</h4>
            </div>
            <div class="card-body mt-0 mb-0" *ngIf="dataMaintenance?.supplier_show?.length > 0">
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 mb-3"
                            *ngFor="let supplier of dataMaintenance?.supplier_show; let i = index">
                            <div class="card h-100 border" [ngClass]="{'disabled-card': supplier?.approved == 0}">
                                <div class="card-body">
                                    <div class="row mb-4 d-flex justify-content-between align-items-center">
                                        <div class="col-auto d-flex align-items-center">
                                            <img src="assets/img/icons/maintenance/license.svg" alt="Location"
                                                width="25" class="me-2">
                                            <h5 class="lh-1 mb-0">Proveedor {{ indexToLetter(i) }}</h5>
                                        </div>
                                        <div class="col-auto">
                                            <h5 class="lh-1 mb-0 text-success">{{supplier?.approved == 1 ? 'APROBADO' : ''}}</h5>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <h5 class="lh-1 mb-1">Nombre del taller</h5>
                                            <p class="mb-0">{{supplier?.supplier?.name || 'No especificado'}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <h5 class="lh-1 mb-1">Ubicación del taller</h5>
                                            <div class="d-flex align-items-center">
                                                <img src="assets/img/icons/maintenance/location-04.svg" alt="PDF"
                                                    width="25" class="me-2">
                                                <p class="mb-0 lh-1.5">{{supplier?.supplier?.direction_address || 'No especificado'}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <h5 class="lh-1 mb-1">Costo del servicio</h5>
                                            <p class="mb-0">{{supplier?.cost | currency}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <h5 class="lh-1 mb-1">Tiempo estimado de reparación</h5>
                                            <p class="mb-0">{{supplier?.estimated_time || 'No especificado'}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <div class="d-flex align-items-center">
                                                <img src="assets/img/icons/maintenance/pdf-02.svg" alt="PDF" width="25"
                                                    class="me-2">
                                                <a class="me-2" [href]="urlPage + '/storage/' + supplier?.attached_url"
                                                    target="_blank" rel="noopener">
                                                    Ver cotización existente
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <h5 class="lh-1 mb-1">Banco</h5>
                                            <p class="mb-0">{{supplier?.supplier?.bank?.name || 'No especificado'}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <h5 class="lh-1 mb-1">Número de cuenta</h5>
                                            <p class="mb-0">{{supplier?.supplier?.account_number | maskCard}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <h5 class="lh-1 mb-1">Nombre del titular</h5>
                                            <p class="mb-0">{{supplier?.supplier?.account_name || 'No especificado'}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <h5 class="lh-1 mb-1">Tipo de pago</h5>
                                            <p class="mb-0">{{supplier?.payment_type?.name || 'No especificado'}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </form>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
